import React, { FC } from 'react';
import { StepInfo } from '../../models';
import './ImageStep.css';

interface ImageStepProps {
  stepInfo: StepInfo
  children?: JSX.Element
}

const ImageStep: FC<ImageStepProps> = ({stepInfo, children}: ImageStepProps) => (
  <div className="ImageStep">
    <img className={`${stepInfo.imageIsFull ? 'full' : ''}${stepInfo.imageIsCenter ? 'center' : ''}`} src={`${process.env.PUBLIC_URL}${stepInfo.imagePath}`} alt="" />
    {children}
  </div>
);

export default ImageStep;
